import { gql, useQuery } from "@apollo/client";

const GET_MEMBER_RELATIONSHIPS = gql`
  query getMemberRelationships($memberId: ID!) {
    account {
      id
      member(id: $memberId) {
        id
        relationships {
          id
          account {
            id
            accountName
          }
          poolType
        }
      }
    }
  }
`;

export const useMemberRelationships = memberId => {
  const { data, loading, error, refetch } = useQuery(GET_MEMBER_RELATIONSHIPS, {
    variables: { memberId },
    fetchPolicy: "network-only",
    skip: !memberId
  });

  return {
    relationships: data?.account?.member?.relationships || [],
    loading,
    error,
    refetch: () => refetch()
  };
};
